module.exports = __webpack_public_path__ + "media/19.51b3d35c.wav";